import { canonicalPath } from './routes'

export { canonicalPath }

/**
 * Corrects the address bar when it holds an old path (see `routes.js`),
 * without a history entry, keeping query and hash, and returns the pathname
 * to route on. `server.js` answers the same old paths with a 301.
 */
export const canonicalizeLocation = (): string => {
  const { pathname, search, hash } = window.location
  const current = pathname + search + hash
  const next = canonicalPath(current)
  if (next !== current) {
    window.history.replaceState(window.history.state, '', next)
    return next.split(/[?#]/)[0]
  }
  return pathname
}
